import { IOrderUser } from 'src/app/features/orders/models/order.model';

export function userInitials(name: string | undefined | null): string {
  const n = name?.trim();
  if (!n) {
    return '?';
  }
  const parts = n.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/** Rows that expose API ownership fields (orders or quotations listing). */
export interface IOwnershipListRow {
  order_creator?: IOrderUser | null;
  owner?: IOrderUser | null;
}

export function dedupeUsersFromOwnershipRows(rows: IOwnershipListRow[]): IOrderUser[] {
  const map = new Map<number, IOrderUser>();
  for (const row of rows) {
    for (const u of [row.order_creator, row.owner]) {
      if (u?.id != null) {
        const prev = map.get(u.id);
        if (!prev || (!prev.email && u.email)) {
          map.set(u.id, { id: u.id, name: u.name, email: u.email });
        }
      }
    }
  }
  return Array.from(map.values()).sort((a, b) =>
    (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' })
  );
}
